import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useApiRequestMutation } from "../../services/apiService";
import ToastrService from "../../services/toastService";
const customSelectStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? "#0782D5" : provided.borderColor,
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? "#0782D5"
            : state.isFocused
                ? "#0782d57a"
                : provided.backgroundColor,
        color: state.isSelected || state.isFocused ? "#fff" : "#000",
        cursor: "pointer",
    }),
};

const UserDrawer = ({
    mode = "add",
    isReadOnly = false,
    roleList = [],
    onClose,
    onSave,
    userData = null,
}) => {
    console.log('userData', userData)
    const isEdit = mode !== "add";
    const [apiRequest, { isLoading }] = useApiRequestMutation();
    const [reportingOptions, setReportingOptions] = useState([]);
    const [reportingUser, setReportingUser] = useState(null);
    const [campaignOptions, setCampaignOptions] = useState([]);

    const [statusOptions] = useState([
        { value: "active", label: "Active" },
        { value: "inactive", label: "Inactive" }
    ]);
    const [initialForm, setInitialForm] = useState(null);
    const today = new Date();
    const maxDate = today.toISOString().split("T")[0];

    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    const minDate = oneMonthAgo.toISOString().split("T")[0];

    const [userForm, setUserForm] = useState({
        employeeId: "",
        dateOfJoining: "",
        firstName: "",
        lastName: "",
        email: "",
        role: null,
        secondaryRole: null,
        reportingUser: null,
        status: null,
        campaign: null,
        department: null


    });

    const [errors, setErrors] = useState({
        employeeId: "",
        dateOfJoining: "",
        firstName: "",
        lastName: "",
        email: "",
        role: "",
        secondaryRole: "",
        reportingUser: "",
        campaign: "",
        department: ""
    });

    const [roleOptions, setRoleOptions] = useState([]);

    useEffect(() => {
        if (userData) {

            const formData = {
                employeeId: userData.employeeId || "",
                firstName: userData.firstName || "",
                lastName: userData.lastName || "",
                email: userData.email || "",
                role: userData.role
                    ? { value: userData.role, label: userData.role }
                    : null,
                reportingUser: userData.reported_by
                    ? { value: userData.reported_by, label: userData.reported_by }
                    : null,
                status: statusOptions.find(
                    (opt) => opt.value === userData.status
                ) || null,
                dateOfJoining: userData.dateOfJoining
                    ? userData.dateOfJoining.split("T")[0]
                    : "",
                // campaign: campaignOptions.find((opt) => opt.id === userData.campaign_id)
                department: userData.department_id
                    ? {
                        value: userData.department_id,
                        label: userData.department_name
                    }
                    : null,
            };

            setUserForm(formData);
            setInitialForm(formData); // ✅ store initial snapshot
        }
    }, [userData]);

    const validateName = (name) => /^[A-Za-z\s]+$/.test(name);

    const validateEmail = (email) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const validateField = (field, value) => {
        let message = "";
        if (field === "employeeId") {
            if (!value.trim()) message = "Employee ID is required";
        }

        // if (field === "dateOfJoining") {
        //     if (!value) message = "Date of Joining is required";
        // }
        if (field === "dateOfJoining") {
            if (!value) {
                message = "Date of Joining is required";
            } else if (isFutureDate(value)) {
                // message = "Future date is not allowed";
                message = "Date of joining must be within last 30 days and not in future";

            }
        }

        // if (field === "firstName") {
        //     if (!value.trim()) message = "First Name is required";
        // }
        // if (field === "lastName") {
        //     if (!value.trim()) message = "Last Name is required";
        // }

        if (field === "firstName") {
            if (!value.trim()) {
                message = "First Name is required";
            } else if (!validateName(value)) {
                message = "First Name should contain only alphabets";
            }
        }

        if (field === "lastName") {
            if (!value.trim()) {
                message = "Last Name is required";
            } else if (!validateName(value)) {
                message = "Last Name should contain only alphabets";
            }
        }
        if (field === "email") {
            if (!value.trim()) message = "Email is required";
            else if (!validateEmail(value))
                message = "Enter valid email address";
        }

        if (field === "role") {
            if (!value) message = "Role is required";
        }
        if (field == "reportingUser") {
            if (!value) message = "Reporting User is required";

        }
        if (field === "status") {
            if (!value) message = "Status is required";
        }
        if (field === "secondaryRole") {
            if (!value) message = "Secondary Role is required";
        }
        if (field === "campaign") {
            if (!value) message = "Campaign is required";
        }
        if (field === 'department') {
            if (!value) message = 'Department is required'
        }
        setErrors((prev) => ({ ...prev, [field]: message }));
    };

    const handleChange = (field, value) => {
        setUserForm((prev) => ({ ...prev, [field]: value }));
        validateField(field, value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        validateField("firstName", userForm.firstName);
        validateField("lastName", userForm.lastName);
        validateField("email", userForm.email);
        validateField("role", userForm.role);
        validateField("department", userForm.department)
        validateField("secondaryRole", userForm.secondaryRole);
        validateField("employeeId", userForm.employeeId);
        validateField("campaign", userForm.campaign);
        // validateField("dateOfJoining", userForm.dateOfJoining);
        validateField("reportingUser", userForm.reportingUser)
        if (isFutureDate(userForm.dateOfJoining)) {
            validateField("dateOfJoining", userForm.dateOfJoining);
            return;
        }
        // validateField("status", userForm.status);
        // if (
        //     !userForm.employeeId ||
        //     !userForm.dateOfJoining ||
        //     !userForm.firstName ||
        //     !userForm.lastName ||
        //     !validateEmail(userForm.email) ||
        //     !userForm.role || !userForm.reportingUser
        //     || (mode !== "add" && !userForm.status)
        // ) {
        //     return;
        // }

        if (isEdit) {
            if (
                !userForm.role ||
                !userForm.reportingUser ||
                (userData?.status !== "unconfirmed" && userData?.status !== 'deleted' && !userForm.status) ||
                !userForm.secondaryRole
            ) {
                validateField("role", userForm.role);
                validateField("reportingUser", userForm.reportingUser);

                if (userData?.status !== "unconfirmed") {
                    validateField("status", userForm.status);
                }

                return;
            }
        } else {
            if (
                !userForm.employeeId ||
                !userForm.dateOfJoining ||
                !userForm.firstName ||
                !userForm.lastName ||
                !validateEmail(userForm.email) ||
                !userForm.role ||
                !userForm.reportingUser || !userForm.campaign || !userForm.department
            ) {
                return;
            }
        }

        // const payload = {
        //     first_name: userForm.firstName,
        //     last_name: userForm.lastName,
        //     email: userForm.email,
        //     role: userForm.role?.value || "",
        //     role_name: userForm.role?.roleName || ""
        // };
        // const payload = {
        //     employee_id: userForm.employeeId,
        //     date_of_joining: userForm.dateOfJoining,
        //     first_name: userForm.firstName,
        //     last_name: userForm.lastName,
        //     email: userForm.email,
        //     primary_role: userForm.role?.value || "",
        //     primary_role_name: userForm.role?.roleName || "",
        //     reported_by: userForm.reportingUser.value,
        //     status: userForm.status?.value   // ✅ added

        // };
        let payload = {};

        if (isEdit) {
            payload = {
                id: userData?.id, // required
                reported_by: userForm.reportingUser?.value,
                status: userForm.status?.value,
                primary_role: userForm.role?.value,
                secondary_role: userForm.secondaryRole?.value || null,
                campaign_id: userForm.campaign?.value,
                department_id: userForm.department.value
            };
        } else {
            payload = {
                employee_id: userForm.employeeId,
                date_of_joining: userForm.dateOfJoining,
                first_name: userForm.firstName,
                last_name: userForm.lastName,
                email: userForm.email,
                primary_role: userForm.role?.value || "",
                primary_role_name: userForm.role?.roleName || "",
                secondary_role: userForm.secondaryRole?.value || null,   // ✅ ADD
                campaign_id: userForm.campaign?.value,
                reported_by: userForm.reportingUser.value,
                department_id: userForm?.department?.value
            };
        }
        try {

            // const res = await apiRequest({
            //     url: "/admin/addUser",
            //     method: "POST",
            //     data: payload
            // }).unwrap();

            const res = await apiRequest({
                url: isEdit ? "/admin/editUser" : "/admin/addUser",
                method: "POST",
                data: payload
            }).unwrap();

            const message =
                res?.message ||
                res?.data?.message ||
                "User created successfully";

            ToastrService.success(message);

            if (onSave) onSave(res);

            handleReset();
            onClose();

        } catch (error) {

            console.error("Create User Error:", error);

            const message =
                error?.data?.message ||
                error?.message ||
                "Failed to create user";

            ToastrService.error(message);
        }
    };

    // const handleReset = () => {
    //     setUserForm({
    //         employeeId: "",
    //         firstName: "",
    //         lastName: "",
    //         email: "",
    //         role: null,
    //         reportingUser: null
    //     });


    //     setErrors({
    //         firstName: "",
    //         lastName: "",
    //         email: "",
    //         role: "",
    //         reportingUser: ""

    //     });
    // };
    const handleReset = () => {
        setUserForm({
            employeeId: "",
            dateOfJoining: "",
            firstName: "",
            lastName: "",
            email: "",
            role: null,
            secondaryRole: null,
            reportingUser: null,
            status: null,
            campaign: null
        });

        setErrors({
            employeeId: "",
            dateOfJoining: "",
            firstName: "",
            lastName: "",
            email: "",
            role: "",
            secondaryRole: "",
            reportingUser: "",
            status: "",
            campaign: ""

        });

        setReportingOptions([]); // optional: clears dependent dropdown
    };
    const isFutureDate = (date) => {
        // if (!date) return false;
        // const selected = new Date(date);
        // const today = new Date();

        // // Normalize time
        // selected.setHours(0, 0, 0, 0);
        // today.setHours(0, 0, 0, 0);

        // return selected > today;
        if (!date) return false;

        const selected = new Date(date);
        const today = new Date();

        selected.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        const oneMonthAgo = new Date(today);
        oneMonthAgo.setMonth(today.getMonth() - 1);

        return selected > today || selected < oneMonthAgo;
    };
    // const getAllRoles = async () => {
    //     try {
    //         const res = await apiRequest({
    //             url: "/role/getAllActiveRole",
    //             method: "GET",
    //         }).unwrap();

    //         // const options =
    //         //     res?.data?.map((role) => ({
    //         //         value: role.role_name,
    //         //         label: role.role_displayname,
    //         //     })) || [];
    //         const options =
    //             res?.data?.map((role) => ({
    //                 value: role.id,              // role id
    //                 label: role.role_displayname,
    //                 roleName: role.role_name
    //             })) || [];

    //         setRoleOptions(options);

    //         if (userData?.role) {
    //             // const selectedRole = options.find(
    //             //     (opt) => opt.value === userData.role
    //             // );
    //             const selectedRole = options.find(
    //                 (opt) => opt.roleName === userData.role
    //             );
    //             if (selectedRole) {
    //                 setUserForm((prev) => ({
    //                     ...prev,
    //                     role: selectedRole,
    //                 }));
    //             }
    //         }
    //     } catch (error) {
    //         console.error("Fetch Roles Error:", error);
    //     }
    // };
    const getAllRoles = async () => {
        try {
            const res = await apiRequest({
                url: "/role/getAllActiveRole",
                method: "GET",
            }).unwrap();

            const roles = res?.data?.roles || [];
            const campaigns = res?.data?.campaign || [];

            // ✅ Role Mapping
            const roleOptions = roles.map((role) => ({
                value: role.id,
                label: role.role_displayname,
                roleName: role.role_name
            }));

            // ✅ Campaign Mapping
            const campaignOptions = campaigns.map((camp) => ({
                value: camp.id,
                label: camp.name
            }));

            setRoleOptions(roleOptions);
            setCampaignOptions(campaignOptions);

            // ✅ Edit mode role prefill
            if (userData?.role) {
                const selectedRole = roleOptions.find(
                    (opt) => opt.roleName === userData.role
                );

                if (selectedRole) {
                    setUserForm((prev) => ({
                        ...prev,
                        role: selectedRole,
                    }));
                }
            }

            // ✅ Edit mode campaign prefill (IMPORTANT)
            if (userData?.campaign_id) {
                const selectedCampaign = campaignOptions.find(
                    (opt) => opt.value == userData.campaign_id
                );

                setUserForm((prev) => ({
                    ...prev,
                    campaign: selectedCampaign || null
                }));
            }

        } catch (error) {
            console.error("Fetch Roles Error:", error);
        }
    };
    useEffect(() => {
        getAllRoles();
        getDepartment()
    }, []);

    const [department, setDepartment] = useState([])

    const getDepartment = async () => {
        try {
            const response = await apiRequest({
                url: "/dropdown/getDropdown",
                method: "POST",
                data: {
                    category: ["department"]
                }
            }).unwrap();

            // console.log(response, 'respon')

            if (response.success) {
                const deptOptions = (response?.data?.department || []).map((dept) => ({
                    label: dept.name,
                    value: dept.id
                }));

                setDepartment(deptOptions);
            }
        } catch (error) {
            console.error("Fetch Roles Error:", error);
        }
    };

    const isFormValid =
        userForm.employeeId &&
        userForm.dateOfJoining &&
        !isFutureDate(userForm.dateOfJoining) &&
        userForm.firstName &&
        userForm.lastName &&
        validateEmail(userForm.email) &&
        userForm.role;


    const getReportingUsers = async (roleId) => {
        try {
            let reportingUserPayload = {
                role: roleId,
                userId: userData && userData.id ? userData.id : ""
            }
            const res = await apiRequest({
                url: `/admin/getReportingUsers`,
                method: "POST",
                data: reportingUserPayload
            }).unwrap();

            const options =
                res?.data?.map((user) => ({
                    value: user.id,
                    label: `${user.name} - ${user.email}`
                })) || [];
            console.log('optionsoptions', options)
            setReportingOptions(options);

        } catch (error) {
            console.error("Reporting Users Fetch Error:", error);
        }
    };

    useEffect(() => {
        const initEditData = async () => {
            if (userData && roleOptions.length > 0) {

                const selectedRole = roleOptions.find(
                    (opt) => opt.roleName === userData.role
                );

                if (selectedRole) {

                    // ✅ Set role first
                    setUserForm((prev) => ({
                        ...prev,
                        role: selectedRole
                    }));

                    // ✅ Fetch reporting users
                    const res = await apiRequest({
                        url: `/admin/getReportingUsers`,
                        method: "POST",
                        data: { role: selectedRole.value, userId: userData.id }
                    }).unwrap();

                    const options =
                        res?.data?.map((user) => ({
                            value: user.id,
                            label: `${user.name} - ${user.email}`
                        })) || [];

                    setReportingOptions(options);

                    // ✅ Match reporting user from options
                    const selectedReportingUser = options.find(
                        (opt) => opt.value === Number(userData.reported_by)
                    );

                    setUserForm((prev) => ({
                        ...prev,
                        reportingUser: selectedReportingUser || null
                    }));

                    const selectedSecondaryRole = roleOptions.find(
                        (opt) => opt.roleName === userData.secondary_role
                    );

                    setUserForm((prev) => ({
                        ...prev,
                        secondaryRole: selectedSecondaryRole || null
                    }));
                }
            }
        };

        initEditData();
    }, [userData, roleOptions]);
    const isFormChanged = () => {
        if (!initialForm) return false;


        return (
            initialForm.role?.value !== userForm.role?.value ||
            initialForm.secondaryRole?.value !== userForm.secondaryRole?.value || // ✅ ADD
            initialForm.reportingUser?.value !== userForm.reportingUser?.value ||
            initialForm.status?.value !== userForm.status?.value
        );
    };

    return (
        <>
            <div
                className="offcanvas offcanvas-end show"
                style={{ visibility: "visible" }}
                tabIndex="-1"
            >
                {/* Header */}
                <div className="offcanvas-header px-4 py-3">
                    <div>
                        <h3 className="mb-1 drawer-header">
                            {mode === "add"
                                ? "Add New User"
                                : "Manage All Users"}
                        </h3>
                        <small className="text-muted">
                            Fill in the details below to create a New User.
                        </small>
                    </div>

                    <button
                        type="button"
                        className="btn-close text-reset"
                        onClick={onClose}
                        aria-label="Close"
                    ></button>
                </div>

                {/* Body */}
                <div className="offcanvas-body px-4 py-3">
                    <h5 className="mt-2">User Information</h5>

                    <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                        <fieldset disabled={isLoading}>
                            {/* First Name / Last Name */}
                            <div className="row g-3 mb-3">
                                <div className="col-md-6">
                                    <label className="form-label">
                                        First Name{" "}
                                        <span className="text-danger">*</span>
                                    </label>

                                    <input
                                        type="text"
                                        className={`form-control ${errors.firstName
                                            ? "is-invalid"
                                            : ""
                                            }`}
                                        value={userForm.firstName}
                                        disabled={isReadOnly || isEdit}
                                        onChange={(e) =>
                                            handleChange(
                                                "firstName",
                                                e.target.value
                                            )
                                        }
                                    />

                                    {errors.firstName && (
                                        <div className="invalid-feedback">
                                            {errors.firstName}
                                        </div>
                                    )}
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">
                                        Last Name{" "}
                                        <span className="text-danger">*</span>
                                    </label>

                                    <input
                                        type="text"
                                        className={`form-control ${errors.lastName ? "is-invalid" : ""}`}
                                        value={userForm.lastName}
                                        disabled={isReadOnly || isEdit}
                                        onChange={(e) =>
                                            handleChange("lastName", e.target.value)
                                        }
                                    />

                                    {errors.lastName && (
                                        <div className="invalid-feedback">
                                            {errors.lastName}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-md-6">
                                    <label className="form-label">
                                        Employee ID <span className="text-danger">*</span>
                                    </label>

                                    <input
                                        type="text"
                                        className={`form-control ${errors.employeeId ? "is-invalid" : ""}`}
                                        value={userForm.employeeId}
                                        disabled={isReadOnly || isEdit}
                                        onKeyDown={(e) => {
                                            if (e.key === " ") e.preventDefault();
                                        }}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\s/g, "");
                                            handleChange("employeeId", value);
                                        }}
                                    />

                                    {errors.employeeId && (
                                        <div className="invalid-feedback">
                                            {errors.employeeId}
                                        </div>
                                    )}
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">
                                        Date of Joining <span className="text-danger">*</span>
                                    </label>

                                    <input
                                        type="date"
                                        className={`form-control ${errors.dateOfJoining ? "is-invalid" : ""}`}
                                        value={userForm.dateOfJoining}
                                        min={minDate}
                                        max={maxDate}
                                        disabled={isReadOnly || isEdit}
                                        onChange={(e) =>
                                            handleChange("dateOfJoining", e.target.value)
                                        }

                                    />

                                    {errors.dateOfJoining && (
                                        <div className="invalid-feedback">
                                            {errors.dateOfJoining}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Email */}
                            <div className="mb-3">
                                <label className="form-label">
                                    User Email Id{" "}
                                    <span className="text-danger">*</span>
                                </label>

                                <input
                                    type="email"
                                    className={`form-control ${errors.email ? "is-invalid" : ""
                                        }`}
                                    value={userForm.email}
                                    disabled={isReadOnly || isEdit}
                                    onChange={(e) =>
                                        handleChange(
                                            "email",
                                            e.target.value
                                        )
                                    }
                                />

                                {errors.email && (
                                    <div className="invalid-feedback">
                                        {errors.email}
                                    </div>
                                )}
                            </div>

                            {/* Role */}
                            <div className="mb-3">
                                <label className="form-label">
                                    Primary Role{" "}
                                    <span className="text-danger">*</span>
                                </label>


                                <Select
                                    options={roleOptions}
                                    value={userForm.role}
                                    // onChange={(option) => {
                                    //     handleChange("role", option);
                                    //     setUserForm((prev) => ({ ...prev, reportingUser: null }));
                                    //     getReportingUsers(option.value);
                                    // }}
                                    onChange={(option) => {
                                        setUserForm((prev) => {
                                            const isSameAsSecondary =
                                                prev.secondaryRole?.value === option?.value;

                                            return {
                                                ...prev,
                                                role: option,
                                                reportingUser: null,
                                                secondaryRole: isSameAsSecondary ? null : prev.secondaryRole
                                            };
                                        });

                                        validateField("role", option);
                                        getReportingUsers(option.value);
                                    }}

                                    isDisabled={isReadOnly}
                                    placeholder="Select Role"
                                    styles={customSelectStyles}
                                    classNamePrefix="react-select"
                                />

                                {errors.role && (
                                    <small className="text-danger">
                                        {errors.role}
                                    </small>
                                )}
                            </div>
                            {/* Reporting Hierarchy */}
                            <div className="mb-3">
                                <label className="form-label">
                                    Reporting To <span className="text-danger">*</span>
                                </label>

                                <Select
                                    options={reportingOptions}
                                    value={userForm.reportingUser}
                                    onChange={(option) =>
                                        handleChange("reportingUser", option)
                                    }
                                    isDisabled={isReadOnly}
                                    placeholder="Select Reporting User"
                                    styles={customSelectStyles}
                                    classNamePrefix="react-select"
                                />

                                {errors.reportingUser && (
                                    <small className="text-danger">
                                        {errors.reportingUser}
                                    </small>
                                )}
                            </div>
                            {/* Role */}
                            <div className="mb-3">
                                <label className="form-label">
                                    Secondary Role{" "}
                                    <span className="text-danger">*</span>
                                </label>



                                {/* <Select
                                    options={roleOptions}
                                    value={userForm.secondaryRole}
                                    onChange={(option) => handleChange("secondaryRole", option)}
                                    isDisabled={isReadOnly}
                                    placeholder="Select Secondary Role"
                                    styles={customSelectStyles}
                                /> */}
                                <Select
                                    options={roleOptions.filter(
                                        (opt) => opt.value !== userForm.role?.value
                                    )}
                                    value={userForm.secondaryRole}
                                    // onChange={(option) => handleChange("secondaryRole", option)}
                                    onChange={(option) => {
                                        setUserForm((prev) => {
                                            const isSameAsPrimary =
                                                prev.role?.value === option?.value;

                                            return {
                                                ...prev,
                                                secondaryRole: isSameAsPrimary ? null : option
                                            };
                                        });

                                        validateField("secondaryRole", option);
                                    }}
                                    isDisabled={isReadOnly}
                                    placeholder="Select Secondary Role"
                                    styles={customSelectStyles}
                                    classNamePrefix="react-select"
                                />
                                {errors.secondaryRole && (
                                    <small className="text-danger">
                                        {errors.secondaryRole}
                                    </small>
                                )}
                            </div>

                            {/* Department */}
                            <div className="mb-3">
                                <label className="form-label">
                                    Department <span className="text-danger">*</span>
                                </label>

                                <Select
                                    options={department}
                                    value={userForm.department}
                                    onChange={(option) =>
                                        handleChange("department", option)
                                    }
                                    isDisabled={isReadOnly}
                                    placeholder="Select Department"
                                    styles={customSelectStyles}
                                    classNamePrefix="react-select"
                                />

                                {errors.department && (
                                    <small className="text-danger">
                                        {errors.department}
                                    </small>
                                )}
                            </div>

                            <div className="mb-3">
                                <label className="form-label">
                                    Campaign Assignment <span className="text-danger">*</span>
                                </label>

                                <Select
                                    options={campaignOptions}
                                    value={userForm.campaign}
                                    onChange={(option) => handleChange("campaign", option)}
                                    isDisabled={isReadOnly}
                                    placeholder="Select Campaign"
                                    styles={customSelectStyles}
                                    classNamePrefix="react-select"
                                />

                                {errors.campaign && (
                                    <small className="text-danger">{errors.campaign}</small>
                                )}
                            </div>
                            {/* {mode !== "add" && ( */}
                            {mode !== "add" && userData?.status !== "unconfirmed" && userData?.status !== 'deleted' && (

                                <div className="mb-3">
                                    <label className="form-label">
                                        Status <span className="text-danger">*</span>
                                    </label>

                                    <Select
                                        options={statusOptions}
                                        value={userForm.status}
                                        onChange={(option) => handleChange("status", option)}
                                        isDisabled={isReadOnly}
                                        placeholder="Select Status"
                                        styles={customSelectStyles}
                                    />

                                    {errors.status && (
                                        <small className="text-danger">{errors.status}</small>
                                    )}
                                </div>
                            )}
                            {/* Buttons */}
                            {!isReadOnly && (
                                <div className="d-flex gap-2 mt-4">

                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={
                                            isLoading ||
                                            (isEdit && !isFormChanged()) ||
                                            (!isEdit && !isFormValid)
                                        }
                                    >
                                        {isLoading
                                            ? "Creating..."
                                            : mode === "add"
                                                ? "Create User"
                                                : "Update User"}
                                    </button>

                                    {mode === "add" && (
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={handleReset} disabled={isLoading}
                                        >
                                            Reset
                                        </button>
                                    )}
                                </div>
                            )}
                        </fieldset>
                    </form>
                </div>
            </div>

            {/* Backdrop */}
            <div
                className="offcanvas-backdrop fade show"
                onClick={onClose}
            ></div>
        </>
    );
};

export default UserDrawer;